<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="my-mind-is-a-scape">
<h1>My Mind Is a Scape</h1>
<p style=" text-indent:1em;">Twin poles</p>
<p>Separated at birth</p>
<p>Two continents</p>
<p>Pulling away from each other</p>
<p>Until they collide</p>
<p>A chunk of me</p>
<p>Has sheared off</p><br/>
<p>Bi-polar isn’t just up and down</p>
<p>It’s two octopuses</p>
<p>Fighting with knives</p>
<p>The king with the sword one day</p>
<p>Content with the grave the next</p>
<p>An invisible civil war</p>
<p>The victor determined</p>
<p>Every day</p><br/>
<p>So little time in the middle</p>
<p>For moments like this</p>
<p>When the past and the present</p>
<p>Just became the future</p>
<p>When I’m up, I wanna stay up</p><br/>
<p>When I am down,</p>
<p>All the pain comes back</p>
<p>Covered with insecurity</p><br/>
<p>I use the pain to climb</p>
<p>Climbing and climbing</p>
<p>Always climbing</p>
<p>I have come to find the beauty</p>
<p>In the beating and the comeback</p>
<p>Laughing at time in the face</p><br/>
<p>The maniac does all the writing</p>
<p>Desperate</p>
<p>To makes his words immortal</p>
<p>The lost and hopeless one</p>
<p>Left to start the fires</p>
<p>To be doused</p>
<p>With blood and ink</p><br/>
<p>Somehow lit</p><br/>
<p>With wet matches</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?5d6730d1